import { render, staticRenderFns } from "./NewChatSourceFilter.vue?vue&type=template&id=4fbae0f0"
import script from "./NewChatSourceFilter.vue?vue&type=script&lang=js"
export * from "./NewChatSourceFilter.vue?vue&type=script&lang=js"
import style0 from "./NewChatSourceFilter.vue?vue&type=style&index=0&id=4fbae0f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports